import React from 'react';
import styles from './JurisdictionsTable.module.css';

interface Jurisdiction {
  name: string;
  policies: number;
}

interface JurisdictionsTableProps {
  isLoading?: boolean;
  jurisdictions?: Jurisdiction[];
}

export const JurisdictionsTable: React.FC<JurisdictionsTableProps> = ({ 
  isLoading = false,
  jurisdictions = []
}) => {
  const hasData = jurisdictions.length > 0;
  const maxPolicies = hasData ? Math.max(...jurisdictions.map(j => j.policies)) : 0;

  const barColors = ['var(--ds-brand-blue)', 'var(--ds-success)', 'var(--ds-brand-blue)', 'var(--ds-danger)', 'var(--primary-500)'];

  if (isLoading) {
    return (
      <div className={`${styles.dataSection} ${styles.skeleton}`} />
    );
  }

  return (
    <div className={styles.dataSection}>
      <h3 className={styles.sectionTitle}>Top Jurisdictions by Activity</h3>
      {!hasData ? (
        <div style={{ padding: '1rem', color: 'var(--ds-text-faint)', fontSize: '0.9rem' }}>
          No data available
        </div>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.jurisdictionsTable}>
            <tbody>
              {jurisdictions.map((jurisdiction, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.rankCell}>{index + 1}</td>
                  <td className={styles.nameCell}>{jurisdiction.name}</td>
                  <td className={styles.barCell}>
                    <div className={styles.barWrapper}>
                      <div 
                        className={styles.barFill}
                        style={{ 
                          width: `${(jurisdiction.policies / maxPolicies) * 100}%`,
                          background: barColors[index % barColors.length],
                        }}
                      />
                    </div>
                  </td>
                  <td className={styles.valueCell}>{jurisdiction.policies.toLocaleString()} policies</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
